import { render, staticRenderFns } from "./AboutMissionList.vue?vue&type=template&id=5b237e4d&scoped=true&"
import script from "./AboutMissionList.vue?vue&type=script&lang=ts&"
export * from "./AboutMissionList.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMissionList.vue?vue&type=style&index=0&id=5b237e4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b237e4d",
  null
  
)

export default component.exports